export default __webpack_public_path__ + "static/img-2-7046592f68520552a4f2f373a46e9062.jpg";